(function () {
  var header = document.querySelector('[data-sticky="sticky-top"]');
  if (!header) return;

  var announcementBars = document.querySelectorAll('.header-announcement');
  var lastScrollY = window.scrollY;
  var ticking = false;
  var THRESHOLD = 180;
  var hidden = false;

  function getHeaderHeight() {
    return header.offsetHeight;
  }

  function hideAll() {
    if (hidden) return;

    window.dispatchEvent(
      new CustomEvent('ixcos:close-header-search')
    );

    hidden = true;
    announcementBars.forEach(function (el) {
      el.classList.add('js-header-hidden');
    });
    header.style.top = '-' + (getHeaderHeight() + 10) + 'px';
  }

  function showAll() {
    if (!hidden) return;
    hidden = false;
    announcementBars.forEach(function (el) {
      el.classList.remove('js-header-hidden');
    });
    header.style.top = '';
  }

  function update() {
    var currentScrollY = window.scrollY;
    var isScrollingDown = currentScrollY > lastScrollY;

    if (currentScrollY <= THRESHOLD) {
      showAll();
    } else if (isScrollingDown) {
      hideAll();
    } else {
      showAll();
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
})();
